import { COLOR_PALETTE } from 'constants/ui';

export const cardContainerStyles = {
  backgroundColor: COLOR_PALETTE.BLUE[1],
  borderRadius: '8px',
  marginTop: '12px',
  marginBottom: 0,
  border: `1px solid ${COLOR_PALETTE.BLUE[3]}`,
  overflow: 'hidden',
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  padding: '10px 12px',
  cursor: 'pointer',
  gap: '8px',
};

export const headerLeftStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
  flex: 1,
  minWidth: 0,
};

export const iconStyles = {
  display: 'flex',
  color: COLOR_PALETTE.BLUE[7],
  flexShrink: 0,
  marginTop: '2px',
};

export const getChevronStyles = isExpanded => ({
  display: 'inline-flex',
  color: 'text.secondary',
  flexShrink: 0,
  marginTop: '2px',
  transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
  transition: 'transform 150ms ease',
});

export const headerTextContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  flex: 1,
  minWidth: 0,
};

export const sectionTextStyles = {
  color: COLOR_PALETTE.BLUE[7],
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const titleTextStyles = {
  color: 'text.primary',
  fontSize: '12px',
};

export const contentStyles = {
  padding: '0 12px 12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  borderTop: `1px solid ${COLOR_PALETTE.BLUE[2]}`,
  paddingTop: '12px',
};

export const excerptStyles = {
  color: 'text.primary',
  '& .ai-section-header': {
    display: 'block',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: 1.45,
    margin: 0,
    marginTop: '12px',
    marginBottom: '4px',
    '&:first-child': {
      marginTop: 0,
    },
  },
  '& .ai-paragraph': {
    margin: 0,
    fontSize: '14px',
    lineHeight: 1.45,
  },
  '& .ai-paragraph + .ai-paragraph': {
    marginTop: '12px',
  },
  '& .ai-list': {
    margin: 0,
    paddingLeft: '20px',
  },
  '& .ai-list-item': {
    fontSize: '14px',
    lineHeight: 1.45,
  },
};

export const actionsContainerStyles = {
  display: 'flex',
  gap: '24px',
  flexWrap: 'wrap',
  paddingTop: '4px',
};

export const actionButtonStyles = {
  color: COLOR_PALETTE.BLUE[7],
  padding: 0,
  minWidth: 0,
  textTransform: 'none',
  fontWeight: 400,
  '&:hover': {
    backgroundColor: 'transparent',
    color: COLOR_PALETTE.BLUE[8],
  },
};

export const unavailableCardContainerStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
  padding: '10px 12px',
  marginTop: '12px',
  borderRadius: '8px',
  border: '1px solid',
  borderColor: 'divider',
  backgroundColor: 'action.hover',
};

export const unavailableIconStyles = {
  display: 'flex',
  color: 'text.secondary',
  flexShrink: 0,
  marginTop: '2px',
};
